import { render, staticRenderFns } from "./EmployeeBenefits.vue?vue&type=template&id=b3266648&"
import script from "./EmployeeBenefits.vue?vue&type=script&lang=js&"
export * from "./EmployeeBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports